module.exports = __webpack_public_path__ + "resource/img/image031Dark.342ab5de.png";